import React from "react";
import { CalendarDaysIcon, CheckIcon, ClipboardListIcon, FileTextIcon, InfoIcon, RefreshCwIcon, TargetIcon, TrendingUpIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { volumes } from "../../data/content";
const volumeIcons = [ClipboardListIcon, TargetIcon, CalendarDaysIcon, TrendingUpIcon, FileTextIcon, RefreshCwIcon];
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-300" data-mp="2o1wllmmc1npu">
      <SectionHeading kicker="Your 6-volume planning collection" title="Six Workbooks. Every Planning Area Covered." data-id="element-301" data-mp="2j9lk4fby1tv6" />

      <div className="mx-auto mt-10 grid max-w-6xl gap-6 md:grid-cols-2" data-id="element-302" data-mp="2ebk1fvifjwk8">
        {volumes.map((v, i) => {
        const Icon = volumeIcons[i];
        return <article key={v.title} className="flex flex-col overflow-hidden rounded-[2rem] bg-white ring-1 ring-navy/10" data-id="element-303" data-mp="25alw99w99j02" data-mpi={i}>
              <div className="flex items-center gap-4 px-5 py-5 sm:px-7" style={{
            backgroundColor: v.color
          }} data-id="element-304" data-mp="20c29j79u836n">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white text-navy" data-id="element-305" data-mp="3342xti9qo6js">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-306" data-mp="37yfjlyyottyp" />
                </span>
                <div data-id="element-307" data-mp="2u6irvw0xlm2u">
                  <p className="font-display text-sm font-bold uppercase tracking-wider text-navy/80" data-id="element-308" data-mp="2u34qor407iwz">Volume {i + 1}</p>
                  <h3 className="font-display text-xl font-bold leading-tight text-navy sm:text-2xl" data-id="element-309" data-mp="3lwdkc1k35rvq">{v.title}</h3>
                </div>
              </div>

              <div className="flex flex-1 flex-col px-5 pb-6 pt-5 sm:px-7" data-id="element-310" data-mp="3qufepimypdmi">
                <p className="font-display text-lg font-semibold leading-snug text-teal-dark" data-id="element-311" data-mp="3cue4vdopyvuw">{v.tagline}</p>
                <p className="mt-2 text-base leading-relaxed text-ink-soft" data-id="element-312" data-mp="3ht7jxajnmux6">{v.description}</p>

                <p className="mt-5 text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-313" data-mp="21fhcbttbtois">Inside you’ll find:</p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-314" data-mp="26goijoftmfnc">
                  {v.inside.map(item => <li key={item} className="flex items-start gap-2 text-base font-semibold leading-snug text-navy" data-id="element-315" data-mp="c199pm19uc03">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-316" data-mp="29byifa9jk1d" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-auto pt-6" data-id="element-317" data-mp="3pdrwp2hp1zct">
                  <p className="rounded-2xl bg-sun-soft px-4 py-3 text-base leading-snug text-navy" data-id="element-318" data-mp="3pfmfob9enhe9">
                    <strong data-id="element-319" data-mp="3kddnhh4cwjd7">The benefit:</strong> {v.benefit}
                  </p>
                  {v.note && <p className="mt-3 flex items-start gap-2 text-sm leading-snug text-ink-soft" data-id="element-320" data-mp="3fhy9mp6cmngs">
                      <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-321" data-mp="3bgd2lkghx3ei" />
                      {v.note}
                    </p>}
                </div>
              </div>
            </article>;
      })}
      </div>

      <CtaButton label="Yes! I want all 6 volumes" className="mt-12" data-id="element-322" data-mp="2rjh4rtrpyxpt" />
    </section>;
}